import { useMutation } from '@tanstack/react-query';

import { scoutClient } from '@/modules/scout-sourcing/scoutClient';
import type { ScoutPreviewCandidatesResponse } from '@/modules/scout-sourcing/types';

type Payload = {
  jobId: string;
  jobSourcingId: string;
  maxCandidates?: number;
};

export const usePreviewCandidatesMutation = () =>
  useMutation<ScoutPreviewCandidatesResponse, Error, Payload>({
    mutationFn: ({ jobId, jobSourcingId, maxCandidates }) =>
      scoutClient.previewCandidates(jobId, jobSourcingId, maxCandidates),
  });
